import { snakeCase } from 'lodash';

export const getActionType = actionName =>
  `REPORT_CENTER/${snakeCase(actionName).toUpperCase()}`;

export const createActionCreator = actionName => payload => ({
  type: getActionType(actionName),
  ...payload,
});
